import * as Url from "../Url";
import * as Services from "../handler";

export interface Country {
  id: number;
  name: string;
  code: string;
  currency_sign: string;
  flag: string;
}

export interface GetCountryDto {
  data: Country[];
}
export async function deleteUser(email: string): Promise<any> {
  let res = await Services.DELETE(Url.DIET_PLAN_DELETE_USER, {email});
  return res;
}

export const searchCountry = async (): Promise<GetCountryDto> => {
  const response = await Services.GET(Url.DIET_PLAN_SELECT_COUNTRY);
  return response as GetCountryDto;
};
